import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Chatbot.css";
import {
    clearAttestationsMessage,
    createAttestationRequestRequest,
    fetchAttestationsRequest,
} from "../../../redux/actions/attestationsActions";

// Mapping complet des réponses du chatbot pour tous les modules SIRH
const responses = {
    // Module Congés et Absences
    congés:
        "Vous avez actuellement 15 jours de congés disponibles (25 jours acquis, 10 jours pris). Votre solde RTT est de 8 jours. Souhaitez-vous faire une demande de congés ?",
    soldeConges:
        "Voici votre solde de congés : \n• Congés payés : 15 jours restants\n• RTT : 8 jours\n• Congés ancienneté : 2 jours\n• Récupération : 3 jours",
    demandeConges:
        "Pour faire une demande de congés, veuillez indiquer la période souhaitée. Je peux vous aider à vérifier la disponibilité et soumettre votre demande à validation.",
    absence:
        "Pour déclarer une absence (maladie, événement familial, etc.), je peux vous guider. Quel type d'absence souhaitez-vous déclarer ?",

    // Module Formation
    formation:
        "Plusieurs formations sont disponibles ce trimestre :\n• Management d'équipe (3 jours)\n• Excel avancé (2 jours)\n• Communication efficace (1 jour)\n• Gestion de projet Agile (4 jours)\n• Leadership (2 jours)\nLaquelle vous intéresse ?",
    catalogueFormation:
        "Notre catalogue de formations 2025 comprend plus de 50 formations réparties en 6 catégories : Management, Bureautique, Soft Skills, Techniques métiers, Langues, et Digital. Souhaitez-vous consulter une catégorie spécifique ?",
    mesFormations:
        "Vous avez suivi 3 formations cette année :\n• Excel intermédiaire (complété - mars 2025)\n• Communication interpersonnelle (complété - juin 2025)\n• Management (en cours - octobre 2025)\nVotre taux de complétion est de 85%.",
    demandeFormation:
        "Pour faire une demande de formation, indiquez-moi la formation qui vous intéresse et je transmettrai votre demande à votre manager et au service RH pour validation.",

    // Module Compétences
    competences:
        "Votre profil de compétences actuel :\n• Compétences techniques : Niveau avancé (8/10)\n• Management : Niveau intermédiaire (6/10)\n• Communication : Niveau avancé (8/10)\n• Gestion de projet : Niveau intermédiaire (7/10)\nSouhaitez-vous consulter le détail ou planifier un développement ?",
    evaluationCompetences:
        "Votre dernière évaluation de compétences date de juin 2025. La prochaine évaluation est prévue pour décembre 2025. Vous pouvez faire une auto-évaluation dès maintenant si vous le souhaitez.",
    planDeveloppement:
        "Votre plan de développement individuel (PDI) comprend 4 objectifs :\n1. Développer vos compétences en leadership\n2. Obtenir une certification PMP\n3. Améliorer votre maîtrise de l'anglais\n4. Acquérir des compétences en Data Analytics",
    cartographieCompetences:
        "Je peux vous montrer la cartographie des compétences de votre équipe ou département. Cela vous aidera à identifier les besoins en formation et les talents disponibles.",

    // Module Recrutement
    recrutement:
        "Actuellement, nous avons 12 postes ouverts dans l'entreprise :\n• 3 postes en développement\n• 2 postes en commercial\n• 4 postes en support client\n• 3 postes en marketing\nSouhaitez-vous consulter les détails ou recommander un candidat ?",
    offresEmploi:
        "Vous pouvez consulter toutes nos offres d'emploi sur notre portail carrières. Souhaitez-vous que je vous envoie le lien ou que je vous présente des postes spécifiques ?",
    recommandation:
        "Vous souhaitez recommander un candidat ? C'est excellent ! Notre programme de cooptation offre une prime de 1500€ si votre candidat est recruté. Dites-moi pour quel poste vous avez un candidat.",
    suiviCandidature:
        "Pour suivre l'état d'une candidature (la vôtre ou celle d'un candidat coopté), veuillez me fournir le numéro de référence ou le nom du candidat.",
    onboarding:
        "Le processus d'intégration d'un nouveau collaborateur dure 3 mois et comprend : accueil, formation initiale, accompagnement par un parrain/marraine, et points réguliers avec le manager.",

    // Module Paie et Rémunération
    paie: "Vos fiches de paie sont disponibles dans votre espace personnel. La dernière fiche de paie (octobre 2025) est disponible. Souhaitez-vous que je vous envoie le lien ?",
    fichePaie:
        "Vous pouvez télécharger toutes vos fiches de paie depuis 2020 dans votre espace personnel > Documents > Bulletins de salaire. Besoin d'aide pour accéder à vos documents ?",
    salaire:
        "Votre salaire brut mensuel est de 3500€. Votre prochain entretien d'évaluation et révision salariale est prévu en janvier 2026.",
    primes:
        "Vous êtes éligible aux primes suivantes :\n• Prime de performance annuelle (selon objectifs)\n• Prime de cooptation (si recommandation)\n• Prime d'ancienneté (après 3 ans)\n• 13ème mois (versé en décembre)",
    avantages:
        "Vos avantages sociaux incluent :\n• Mutuelle d'entreprise (prise en charge 60%)\n• Tickets restaurant (valeur 9€)\n• CSE (activités culturelles et sportives)\n• Télétravail (2 jours/semaine)\n• Plan d'épargne entreprise (PEE)",

    // Module Performance et Évaluation
    evaluation:
        "Votre dernier entretien annuel d'évaluation a eu lieu en janvier 2025. Score global : 8.2/10. Points forts : collaboration, résultats. Axes d'amélioration : gestion du temps. Prochain entretien : janvier 2026.",
    objectifs:
        "Vos objectifs pour 2025 :\n• Augmenter le CA de 15% (en cours - 78% atteint)\n• Manager une équipe de 3 personnes (atteint)\n• Obtenir une certification professionnelle (en cours)\n• Réduire les délais de livraison de 20% (atteint)",
    feedbacks:
        "Vous avez reçu 8 feedbacks ce trimestre. Note moyenne : 4.3/5. Vous pouvez consulter les détails dans votre espace personnel ou demander un feedback à un collègue.",
    entretienProfessionnel:
        "Votre entretien professionnel obligatoire (tous les 2 ans) est prévu pour mars 2026. Cet entretien portera sur votre parcours, vos compétences et votre projet professionnel.",

    // Module Carrière et Mobilité
    carriere:
        "Vous êtes actuellement Chef de projet senior (niveau 7). Les évolutions possibles : Manager de projet, Directeur de projet, ou spécialisation technique (Expert). Souhaitez-vous explorer les opportunités ?",
    mobiliteInterne:
        "3 postes en mobilité interne correspondent à votre profil :\n• Manager d'équipe - Paris (CDI)\n• Chef de projet senior - Lyon (CDI)\n• Responsable développement - Marseille (CDI)\nSouhaitez-vous plus d'informations ?",
    planCarriere:
        "Votre plan de carrière à 5 ans : Année 1-2 : consolidation du poste actuel. Année 3 : évolution vers management. Année 4-5 : poste de direction. Voulez-vous en discuter avec votre manager ?",

    // Module Documents RH
    documents:
        "Documents disponibles dans votre espace :\n• Contrat de travail\n• Attestations (emploi, salaire)\n• Fiches de paie (2020-2025)\n• Certificats de formation\n• Comptes-rendus d'entretiens\nQuel document recherchez-vous ?",
    attestation:
        "Je peux générer les attestations suivantes :\n• Attestation d'emploi\n• Attestation de salaire\n• Certificat de travail\n• Attestation pour la CAF\nLaquelle souhaitez-vous obtenir ?",
    contrat:
        "Votre contrat de travail (CDI temps plein) est disponible dans votre espace personnel > Documents RH. Date d'entrée : 15 mars 2022. Souhaitez-vous consulter un avenant ?",

    // Module Temps de Travail
    pointage:
        "Votre temps de travail ce mois-ci : 145h effectuées sur 151.67h attendues. Heures supplémentaires : 0h. RTT générés : 1 jour. Pensez à pointer vos entrées/sorties quotidiennes !",
    horaires:
        "Vos horaires de travail : 9h-12h30 et 13h30-18h (lundi au vendredi). Vous bénéficiez de la flexibilité des horaires (±1h) et de 2 jours de télétravail par semaine.",
    heuresSupplementaires:
        "Vous avez 0 heures supplémentaires ce mois-ci. Les heures supplémentaires sont compensées en récupération ou rémunérées selon la politique de l'entreprise (majoration de 25%).",

    // Module Communication Interne
    actualites:
        "Dernières actualités RH :\n• Nouveau programme de formation 2025 lancé\n• Télétravail : nouvelle charte signée\n• Enquête satisfaction collaborateurs en novembre\n• Journée portes ouvertes recrutement le 15 décembre",
    evenements:
        "Prochains événements :\n• Team building département (20 novembre)\n• Séminaire entreprise (5-6 décembre)\n• Fête de fin d'année (18 décembre)\n• Galette des rois (15 janvier)\nInscription obligatoire !",

    // Réponse par défaut
    default:
        "Je comprends votre demande. Je peux vous aider sur les sujets suivants :\n📅 Congés & Absences\n📚 Formations\n💼 Compétences\n👥 Recrutement\n💰 Paie & Rémunération\n📊 Performance\n🎯 Carrière\n📄 Documents RH\n⏰ Temps de travail\n\nUn conseiller RH peut aussi vous contacter sous 24h pour une question spécifique.",
};

// Composants Message, Suggestions, TypingIndicator
const Message = ({ text, sender, time }) => (
    <div className={`message ${sender}`}>
        <div className="message-avatar">{sender === "bot" ? "🤖" : "👤"}</div>
        <div>
            <div className="message-content">{text}</div>
            <div className="message-time">{time}</div>
        </div>
    </div>
);

const Suggestions = ({ suggestions, onSendSuggestion }) => (
    <div className="suggestions">
        {suggestions.map((suggestion, index) => (
            <button
                key={index}
                className="suggestion-btn"
                onClick={() => onSendSuggestion(suggestion.text)}
            >
                {suggestion.icon} {suggestion.text}
            </button>
        ))}
    </div>
);

const TypingIndicator = () => (
    <div className="message bot typing-indicator active">
        <div className="message-avatar">🤖</div>
        <div className="typing-dots">
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
        </div>
    </div>
);

const initialSuggestions = [
    { text: "Consulter mes congés", icon: "📅" },
    { text: "Voir les formations", icon: "📚" },
    { text: "Mes compétences", icon: "💼" },
    { text: "Offres d'emploi", icon: "👥" },
    { text: "Mes fiches de paie", icon: "💰" },
    { text: "Mon évaluation", icon: "📊" },
];

function Chatbot() {
    const dispatch = useDispatch();
    const attestationState = useSelector((state) => state.attestations || {});
    const attestations = attestationState.attestations || [];
    const [isOpen, setIsOpen] = useState(false);
    const [isMaximized, setIsMaximized] = useState(false);
    const [messages, setMessages] = useState([
        {
            text: "Bonjour ! Je suis votre assistant RH virtuel. Comment puis-je vous aider aujourd'hui ?",
            sender: "bot",
            time: new Date().toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
            }),
            isInitial: true,
        },
    ]);
    const [input, setInput] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [isTranscribing, setIsTranscribing] = useState(false);
    const messagesEndRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const audioStreamRef = useRef(null);
    const attestationRequestPendingRef = useRef(false);

    useEffect(() => {
        if (isOpen && attestations.length === 0) {
            dispatch(fetchAttestationsRequest());
        }
    }, [isOpen, attestations.length, dispatch]);

    useEffect(() => () => {
        audioStreamRef.current?.getTracks().forEach((track) => track.stop());
    }, []);

    const scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        if (isOpen) {
            scrollToBottom();
        }
    }, [messages, isTyping, isOpen]);

    const getBotResponse = (message) => {
        const lowerMessage = message.toLowerCase();

        // Module Congés et Absences
        if (lowerMessage.includes("congé") || lowerMessage.includes("vacances")) {
            return responses.congés;
        }
        if (lowerMessage.includes("solde") && (lowerMessage.includes("congé") || lowerMessage.includes("rtt"))) {
            return responses.soldeConges;
        }
        if (lowerMessage.includes("demande") && lowerMessage.includes("congé")) {
            return responses.demandeConges;
        }
        if (lowerMessage.includes("absence") || lowerMessage.includes("maladie")) {
            return responses.absence;
        }

        // Module Formation
        if (lowerMessage.includes("formation") || lowerMessage.includes("cours")) {
            return responses.formation;
        }
        if (lowerMessage.includes("catalogue") && lowerMessage.includes("formation")) {
            return responses.catalogueFormation;
        }
        if (lowerMessage.includes("mes formations") || lowerMessage.includes("formations suivies")) {
            return responses.mesFormations;
        }
        if (lowerMessage.includes("demande") && lowerMessage.includes("formation")) {
            return responses.demandeFormation;
        }

        // Module Compétences
        if (lowerMessage.includes("compétence") || lowerMessage.includes("skill")) {
            return responses.competences;
        }
        if (lowerMessage.includes("évaluation") && lowerMessage.includes("compétence")) {
            return responses.evaluationCompetences;
        }
        if (lowerMessage.includes("plan de développement") || lowerMessage.includes("pdi")) {
            return responses.planDeveloppement;
        }
        if (lowerMessage.includes("cartographie") && lowerMessage.includes("compétence")) {
            return responses.cartographieCompetences;
        }

        // Module Recrutement
        if (lowerMessage.includes("recrutement") || lowerMessage.includes("poste") || lowerMessage.includes("emploi")) {
            return responses.recrutement;
        }
        if (lowerMessage.includes("offre") && lowerMessage.includes("emploi")) {
            return responses.offresEmploi;
        }
        if (lowerMessage.includes("recommand") || lowerMessage.includes("cooptation") || lowerMessage.includes("coopter")) {
            return responses.recommandation;
        }
        if (lowerMessage.includes("candidature") || lowerMessage.includes("suivi")) {
            return responses.suiviCandidature;
        }
        if (lowerMessage.includes("onboarding") || lowerMessage.includes("intégration") || lowerMessage.includes("integration")) {
            return responses.onboarding;
        }

        // Module Paie et Rémunération
        if (lowerMessage.includes("paie") || lowerMessage.includes("bulletin") || lowerMessage.includes("fiche de paie")) {
            return responses.paie;
        }
        if (lowerMessage.includes("télécharger") && lowerMessage.includes("paie")) {
            return responses.fichePaie;
        }
        if (lowerMessage.includes("salaire") || lowerMessage.includes("rémunération") || lowerMessage.includes("remuneration")) {
            return responses.salaire;
        }
        if (lowerMessage.includes("prime")) {
            return responses.primes;
        }
        if (lowerMessage.includes("avantage") || lowerMessage.includes("mutuelle") || lowerMessage.includes("ticket")) {
            return responses.avantages;
        }

        // Module Performance et Évaluation
        if (lowerMessage.includes("évaluation") || lowerMessage.includes("evaluation") || lowerMessage.includes("entretien annuel")) {
            return responses.evaluation;
        }
        if (lowerMessage.includes("objectif")) {
            return responses.objectifs;
        }
        if (lowerMessage.includes("feedback") || lowerMessage.includes("retour")) {
            return responses.feedbacks;
        }
        if (lowerMessage.includes("entretien professionnel")) {
            return responses.entretienProfessionnel;
        }

        // Module Carrière et Mobilité
        if (lowerMessage.includes("carrière") || lowerMessage.includes("carriere") || lowerMessage.includes("évolution") || lowerMessage.includes("evolution")) {
            return responses.carriere;
        }
        if (lowerMessage.includes("mobilité") || lowerMessage.includes("mobilite") || lowerMessage.includes("mutation")) {
            return responses.mobiliteInterne;
        }
        if (lowerMessage.includes("plan") && lowerMessage.includes("carrière")) {
            return responses.planCarriere;
        }

        // Module Documents RH
        if (lowerMessage.includes("document")) {
            return responses.documents;
        }
        if (lowerMessage.includes("attestation")) {
            return responses.attestation;
        }
        if (lowerMessage.includes("contrat")) {
            return responses.contrat;
        }

        // Module Temps de Travail
        if (lowerMessage.includes("pointage") || lowerMessage.includes("temps de travail") || lowerMessage.includes("heures")) {
            return responses.pointage;
        }
        if (lowerMessage.includes("horaire")) {
            return responses.horaires;
        }
        if (lowerMessage.includes("heure") && lowerMessage.includes("supplémentaire")) {
            return responses.heuresSupplementaires;
        }

        // Module Communication Interne
        if (lowerMessage.includes("actualité") || lowerMessage.includes("actualite") || lowerMessage.includes("news") || lowerMessage.includes("nouveau")) {
            return responses.actualites;
        }
        if (lowerMessage.includes("événement") || lowerMessage.includes("evenement") || lowerMessage.includes("séminaire") || lowerMessage.includes("seminaire")) {
            return responses.evenements;
        }

        // Réponse par défaut
        return responses.default;
    };

    const addMessage = (text, sender) => {
        const now = new Date();
        const time = now.toLocaleTimeString("fr-FR", {
            hour: "2-digit",
            minute: "2-digit",
        });

        setMessages((prevMessages) => [...prevMessages, { text, sender, time }]);
    };

    useEffect(() => {
        if (!attestationRequestPendingRef.current || !attestationState.message) return;

        attestationRequestPendingRef.current = false;
        setIsTyping(false);
        addMessage("Demande envoyée. Vous pouvez la retrouver dans Mes attestations.", "bot");
        dispatch(clearAttestationsMessage());
    }, [attestationState.message, dispatch]);

    useEffect(() => {
        if (!attestationRequestPendingRef.current || !attestationState.error) return;

        attestationRequestPendingRef.current = false;
        setIsTyping(false);
        addMessage(`La demande n'a pas pu être envoyée : ${attestationState.error}`, "bot");
        dispatch(clearAttestationsMessage());
    }, [attestationState.error, dispatch]);

    const normalizeText = (value) => String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const getRequestedAttestationKeywords = (message) => {
        const normalizedMessage = normalizeText(message);
        const containsRequest = /(je veux|je souhaite|j aimerais|faire une demande|demander|obtenir)/.test(normalizedMessage);

        if (!containsRequest || !/(attestation|certificat)/.test(normalizedMessage)) return null;
        if (/(salaire|salariale|remuneration)/.test(normalizedMessage)) {
            return ["salaire", "salariale", "remuneration"];
        }
        if (/(travail|emploi|professionnelle)/.test(normalizedMessage)) {
            return ["travail", "emploi", "professionnelle"];
        }
        return [];
    };

    const sendAttestationRequest = (message) => {
        const keywords = getRequestedAttestationKeywords(message);
        if (keywords === null) return false;

        const attestation = attestations.find((item) => {
            if (item?.actif === false) return false;
            const title = normalizeText(item?.titre || item?.nom || item?.name);
            return keywords.some((keyword) => title.includes(keyword));
        });

        if (!attestation) {
            addMessage(
                attestations.length === 0
                    ? "Le catalogue des attestations est en cours de chargement. Réessayez dans quelques secondes."
                    : "Ce type d'attestation n'est pas disponible dans le catalogue.",
                "bot"
            );
            return true;
        }

        dispatch(clearAttestationsMessage());
        attestationRequestPendingRef.current = true;
        setIsTyping(true);
        dispatch(createAttestationRequestRequest({
            attestationId: attestation.id,
            motif: "Demande effectuée depuis l'assistant RH vocal",
            commentaire: "",
            dateLimitePreparation: "",
            attachments: [],
        }));
        return true;
    };

    const sendMessage = async (messageText = input) => {
        const trimmedMessage = messageText.trim();

        if (!trimmedMessage) return;

        addMessage(trimmedMessage, "user");
        setInput("");

        if (sendAttestationRequest(trimmedMessage)) return;

        setIsTyping(true);

        await new Promise((resolve) => setTimeout(resolve, 1500));

        setIsTyping(false);
        const botResponse = getBotResponse(trimmedMessage);
        addMessage(botResponse, "bot");
    };

    const stopAudioStream = () => {
        audioStreamRef.current?.getTracks().forEach((track) => track.stop());
        audioStreamRef.current = null;
    };

    const transcribeRecording = async (audioBlob) => {
        setIsTranscribing(true);
        try {
            const formData = new FormData();
            formData.append("audio", audioBlob, "recording.webm");

            const response = await fetch("http://127.0.0.1:5000/transcribe", {
                method: "POST",
                body: formData,
            });
            const data = await response.json();

            if (!response.ok || !data.transcription) {
                throw new Error(data.error || "Transcription impossible");
            }

            await sendMessage(data.transcription);
        } catch (error) {
            addMessage(`Erreur de transcription : ${error.message}`, "bot");
        } finally {
            setIsTranscribing(false);
        }
    };

    const toggleRecording = async () => {
        if (isRecording) {
            mediaRecorderRef.current?.stop();
            setIsRecording(false);
            return;
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const recorder = new MediaRecorder(stream);

            audioStreamRef.current = stream;
            audioChunksRef.current = [];
            mediaRecorderRef.current = recorder;

            recorder.ondataavailable = (event) => {
                if (event.data.size > 0) audioChunksRef.current.push(event.data);
            };
            recorder.onstop = () => {
                const audioBlob = new Blob(audioChunksRef.current, {
                    type: recorder.mimeType || "audio/webm",
                });
                stopAudioStream();
                transcribeRecording(audioBlob);
            };

            recorder.start();
            setIsRecording(true);
        } catch (error) {
            stopAudioStream();
            addMessage("Impossible d'accéder au microphone. Vérifiez son autorisation dans le navigateur.", "bot");
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            sendMessage();
        }
    };

    const toggleChat = () => {
        setIsOpen(!isOpen);
        setIsMaximized(false);
    };

    const toggleMaximize = () => {
        setIsMaximized(!isMaximized);
    };

    return (
        <>
            {/* Icône Flottante */}
            <div
                className={`chatbot-float-icon ${isOpen ? 'hidden' : ''}`}
                onClick={toggleChat}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12C2 13.54 2.38 14.98 3.06 16.26L2 22L7.74 20.94C9.02 21.62 10.46 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C10.69 20 9.45 19.67 8.36 19.09L8 18.91L4.55 19.82L5.46 16.37L5.28 16.01C4.7 14.92 4.37 13.68 4.37 12.37C4.37 7.97 7.97 4.37 12.37 4.37C16.77 4.37 20.37 7.97 20.37 12.37C20.37 16.77 16.63 20 12 20Z"
                        fill="white"
                    />
                    <circle cx="9" cy="12" r="1" fill="white"/>
                    <circle cx="12" cy="12" r="1" fill="white"/>
                    <circle cx="15" cy="12" r="1" fill="white"/>
                </svg>
                <div className="chatbot-pulse-ring"></div>
            </div>

            {/* Chatbot (Minimisé ou Modal) */}
            {isOpen && (
                <>
                    {isMaximized && <div className="chatbot-modal-overlay" onClick={toggleMaximize}></div>}

                    <div className={`chat-container ${isMaximized ? 'maximized' : 'minimized'}`}>
                        {/* Header du Chat */}
                        <div className="chat-header">
                            <div className="avatar">🤖</div>
                            <div className="header-info">
                                <h2>Assistant RH</h2>
                            </div>

                            {/* Boutons de contrôle */}
                            <button
                                className="control-btn maximize-btn"
                                onClick={toggleMaximize}
                                title={isMaximized ? "Réduire" : "Agrandir"}
                            >
                                {isMaximized ? (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 14H10V20M20 10H14V4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                ) : (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15 3H21V9M9 21H3V15M21 3L14 10M3 21L10 14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                )}
                            </button>

                            <button className="control-btn close-btn" onClick={toggleChat}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div>

                        {/* Zone de Messages */}
                        <div className="chat-messages">
                            {messages.map((msg, index) => (
                                <React.Fragment key={index}>
                                    <Message text={msg.text} sender={msg.sender} time={msg.time} />
                                    {msg.isInitial && msg.sender === "bot" && (
                                        <Suggestions
                                            suggestions={initialSuggestions}
                                            onSendSuggestion={sendMessage}
                                        />
                                    )}
                                </React.Fragment>
                            ))}
                            {/* Indicateur de frappe */}
                            {isTyping && <TypingIndicator />}
                            <div ref={messagesEndRef} />
                        </div>

                        {/* Zone d'Input */}
                        <div className="chat-input-area">
                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    id="userInput"
                                    placeholder={isRecording ? "Écoute en cours..." : "Tapez votre message..."}
                                    value={input}
                                    onChange={(e) => setInput(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                    disabled={isRecording || isTranscribing}
                                />
                                <button
                                    type="button"
                                    className="icon-btn"
                                    onClick={toggleRecording}
                                    disabled={isTranscribing}
                                    title={isRecording ? "Arrêter l'enregistrement" : "Parler"}
                                    aria-label={isRecording ? "Arrêter l'enregistrement" : "Démarrer l'enregistrement"}
                                    style={{
                                        flexShrink: 0,
                                        background: isRecording ? "#dc2626" : "#e2e8f0",
                                        color: isRecording ? "#fff" : "#2f4595",
                                    }}
                                >
                                    {isRecording ? "■" : "🎙"}
                                </button>
                                <button
                                    className="icon-btn send-btn"
                                    onClick={() => sendMessage()}
                                    disabled={!input.trim() || isRecording || isTranscribing}
                                >
                                    ➤
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default Chatbot;
